/**
 * FikoTeklif Dialog — Anlık Teklif/Maliyet Motoru UI
 * Model/STP → ağırlık (FikoMassInfo) + malzeme fiyatı + işleme süresi → fiyat teklifi + yazdırma.
 */
import { Component, Input, ChangeDetectorRef, ChangeDetectionStrategy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { FikoMassInfo, MALZEMELER } from '../fiko-mass-info/FikoMassInfo';
import { MALZEME_PIYASA, teklifHesapla, TeklifSonuc } from './FikoTeklif';
import { baglamOku, baglamYaz } from '../fiko-uretim-baglam/UretimBaglam';
import { KalicilikService } from '../fiko-kalicilik/kalicilik.service';

@Component({
  selector: 'fikoyt-teklif',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, FormsModule],
  template: `
  <div class="tk">
    <div class="tk-row">
      <label>Malzeme</label>
      <select [(ngModel)]="malzemeIdx" (ngModelChange)="malzemeDegisti()">
        @for (m of malzemeler; track $index) { <option [ngValue]="$index">{{ m.ad }}</option> }
      </select>
    </div>
    <div class="tk-grid">
      <div class="tk-in"><label>Malzeme ₺/kg</label><input type="number" [(ngModel)]="fiyatKg" (ngModelChange)="hesapla()" min="0"></div>
      <div class="tk-in"><label>İşleme cm³/dk</label><input type="number" [(ngModel)]="mrr" (ngModelChange)="hesapla()" min="0.1" step="0.5"></div>
      <div class="tk-in"><label>Saat ₺</label><input type="number" [(ngModel)]="saatUcreti" (ngModelChange)="hesapla()" min="0"></div>
      <div class="tk-in"><label>Kurulum dk</label><input type="number" [(ngModel)]="kurulumDk" (ngModelChange)="hesapla()" min="0"></div>
      <div class="tk-in"><label>Fire %</label><input type="number" [(ngModel)]="fireYuzde" (ngModelChange)="hesapla()" min="0"></div>
      <div class="tk-in"><label>Kaplama ₺</label><input type="number" [(ngModel)]="kaplama" (ngModelChange)="hesapla()" min="0"></div>
      <div class="tk-in"><label>Kâr %</label><input type="number" [(ngModel)]="karYuzde" (ngModelChange)="hesapla()" min="0"></div>
      <div class="tk-in"><label>KDV %</label><input type="number" [(ngModel)]="kdvYuzde" (ngModelChange)="hesapla()" min="0"></div>
      <div class="tk-in"><label>Adet</label><input type="number" [(ngModel)]="adet" (ngModelChange)="hesapla()" min="1"></div>
    </div>
    <button class="tk-btn primary" (click)="olcVeHesapla()">⚙️ Modeli Ölç & Hesapla</button>

    @if (sonuc) {
      <div class="tk-sonuc">
        <div class="tk-r"><span>Net / Brüt ağırlık</span><b>{{ f(netKg,2) }} / {{ f(brutKg,2) }} kg</b></div>
        <div class="tk-r"><span>Hammadde</span><b>{{ f(sonuc.hammaddeMaliyet) }} ₺</b></div>
        <div class="tk-r"><span>İşleme ({{ f(sonuc.islemeSureDk,0) }} dk)</span><b>{{ f(sonuc.islemeMaliyet) }} ₺</b></div>
        <div class="tk-r"><span>Kurulum (birim)</span><b>{{ f(sonuc.kurulumBirim) }} ₺</b></div>
        @if (kaplama > 0) { <div class="tk-r"><span>Kaplama/işlem</span><b>{{ f(sonuc.kaplamaMaliyet) }} ₺</b></div> }
        <div class="tk-r alt"><span>Birim maliyet</span><b>{{ f(sonuc.birimMaliyet) }} ₺</b></div>
        <div class="tk-r"><span>Kâr (%{{ karYuzde }})</span><b>{{ f(sonuc.birimKar) }} ₺</b></div>
        <div class="tk-r vurgu"><span>Birim fiyat (KDV hariç)</span><b>{{ f(sonuc.birimFiyat) }} ₺</b></div>
        <div class="tk-r"><span>Birim (KDV dahil)</span><b>{{ f(sonuc.birimKdvli) }} ₺</b></div>
        <div class="tk-r toplam"><span>TOPLAM ({{ adet }} ad · KDV dahil)</span><b>{{ f(sonuc.toplamKdvli) }} ₺</b></div>
      </div>
      <div class="tk-kayit-row">
        <input [(ngModel)]="parcaAd" placeholder="Parça adı/no" class="tk-parca">
        <button class="tk-btn kaydet" (click)="kaydet()">💾 Kaydet</button>
      </div>
      @if (kayitDurum) { <div class="tk-kayit-durum">{{ kayitDurum }}</div> }
      <button class="tk-btn" (click)="yazdir()">🖨️ Teklif Yazdır / PDF</button>
      @if (ana) {
        <button class="tk-btn ilgili" (click)="ilgiliAc('acIsEmriDialog')">▣ İş Emri Oluştur →</button>
        <button class="tk-btn ilgili" (click)="ilgiliAc('acKayitlarDialog')">📂 Kayıtlı Teklifler →</button>
      }
    }
    @if (hata) { <div class="tk-hata">{{ hata }}</div> }
  </div>
  `,
  styles: [`
    .tk { padding:10px; min-width:280px; max-width:320px; font-size:11px; color:#e6f6ff;
      background:linear-gradient(180deg,rgba(0,40,60,.96),rgba(0,18,36,.98)); border-radius:6px; }
    .tk-row { display:flex; justify-content:space-between; align-items:center; margin-bottom:8px; }
    .tk-row label { color:#5fd9f5; font-weight:600; }
    .tk-row select { flex:1; margin-left:8px; background:rgba(0,60,80,.8); border:1px solid rgba(0,200,220,.4); color:#fff; padding:4px; border-radius:4px; }
    .tk-grid { display:grid; grid-template-columns:1fr 1fr 1fr; gap:5px; margin-bottom:8px; }
    .tk-in { display:flex; flex-direction:column; gap:2px; }
    .tk-in label { font-size:9px; color:#5fd9f5; }
    .tk-in input { background:rgba(0,60,80,.8); border:1px solid rgba(0,200,220,.35); color:#fff; padding:4px; border-radius:4px; font-size:10px; width:100%; box-sizing:border-box; outline:none; }
    .tk-in input:focus { border-color:#33e0ff; }
    .tk-btn { width:100%; padding:8px; margin-top:4px; border:1px solid rgba(0,200,220,.5); background:rgba(0,70,90,.7); color:#fff; border-radius:5px; font-weight:600; cursor:pointer; transition:.15s; }
    .tk-btn:hover { background:rgba(0,110,135,.85); }
    .tk-btn.primary { background:linear-gradient(90deg,#0a84c0,#0bb39e); border:none; }
    .tk-btn.ilgili { background:rgba(0,90,110,.6); border:1px solid rgba(0,200,220,.3); font-size:11px; }
    .tk-kayit-row { display:flex; gap:5px; margin-top:6px; }
    .tk-parca { flex:1; background:rgba(0,60,80,.8); border:1px solid rgba(0,200,220,.35); color:#fff; padding:5px; border-radius:4px; outline:none; min-width:0; }
    .tk-btn.kaydet { width:auto; padding:6px 12px; margin:0; background:linear-gradient(90deg,#1f9e5a,#34c77b); border:none; }
    .tk-kayit-durum { font-size:10px; color:#7dffc0; text-align:center; margin-top:3px; }
    .tk-sonuc { margin-top:10px; background:rgba(0,0,0,.35); border:1px solid rgba(0,200,220,.3); border-radius:5px; padding:8px; }
    .tk-r { display:flex; justify-content:space-between; padding:3px 0; border-bottom:1px solid rgba(0,200,220,.12); }
    .tk-r span { color:#9fe8f7; } .tk-r b { color:#fff; }
    .tk-r.alt { margin-top:3px; border-top:1px dashed rgba(0,200,220,.3); }
    .tk-r.vurgu { background:rgba(0,200,120,.16); margin:4px -8px; padding:6px 8px; border:none; }
    .tk-r.vurgu b { color:#7dffc0; font-size:13px; }
    .tk-r.toplam { background:rgba(255,180,0,.14); margin:2px -8px -2px; padding:6px 8px; border:none; }
    .tk-r.toplam b { color:#ffd76a; font-size:13px; }
    .tk-hata { margin-top:8px; padding:6px; background:rgba(255,50,50,.2); border:1px solid rgba(255,100,100,.4); border-radius:4px; color:#ff9a9a; text-align:center; }
  `]
})
export class FikoTeklifComponent {
  @Input() anaGosterim: any = null;
  @Input() pencere: any;
  @Input() ayarlar: any = {};
  @Input() modelleme: any = null;
  @Input() ana: any = null;

  malzemeler = MALZEMELER;
  malzemeIdx = 1;            // Çelik varsayılan
  fiyatKg = 42; mrr = 12; saatUcreti = 750; kurulumDk = 45;
  fireYuzde = 15; kaplama = 0; karYuzde = 35; kdvYuzde = 20; adet = 1;

  netKg = 0; brutKg = 0; talasCm3 = 0;
  sonuc: TeklifSonuc | null = null;
  hata: string | null = null;
  private mass = new FikoMassInfo();

  private kalicilik = inject(KalicilikService);
  parcaAd = ''; kayitDurum = '';

  constructor(private cd: ChangeDetectorRef) {
    const yuk = this.kalicilik.yuklenecekAl('teklif');   // Kayıtlar panelinden "Yükle"
    if (yuk) { Object.assign(this, yuk); setTimeout(() => this.hesapla(), 0); return; }
    const b = baglamOku();   // önceki analizden malzeme ön-seçimi
    if (b.guncel) {
      if (b.malzeme) { const i = this.malzemeler.findIndex(m => m.ad === b.malzeme); if (i >= 0) { this.malzemeIdx = i; const p = MALZEME_PIYASA[b.malzeme]; if (p) { this.fiyatKg = p.fiyatKg; this.mrr = p.mrr; } } }
      if (b.parcaAd) this.parcaAd = b.parcaAd; else if (b.olcu) this.parcaAd = 'Parça ' + b.olcu;
    }
  }

  /** Mevcut teklifi DB + local'e kaydet (offline-first). */
  async kaydet(): Promise<void> {
    if (!this.sonuc) { this.kayitDurum = 'Önce hesapla'; this.cd.detectChanges(); return; }
    const veri = { parcaAd: this.parcaAd, malzemeIdx: this.malzemeIdx, fiyatKg: this.fiyatKg, mrr: this.mrr, saatUcreti: this.saatUcreti, kurulumDk: this.kurulumDk, fireYuzde: this.fireYuzde, kaplama: this.kaplama, karYuzde: this.karYuzde, kdvYuzde: this.kdvYuzde, adet: this.adet, netKg: this.netKg, brutKg: this.brutKg, talasCm3: this.talasCm3, sonuc: this.sonuc };
    const baslik = (this.parcaAd || this.malzemeler[this.malzemeIdx].ad) + ' · ' + this.f(this.sonuc.birimKdvli) + '₺';
    this.kayitDurum = 'Kaydediliyor…'; this.cd.detectChanges();
    const k = await this.kalicilik.kaydet('teklif', baslik, veri);
    this.kayitDurum = k._sync ? '✓ Kaydedildi (DB)' : '✓ Kaydedildi (yerel)';
    this.cd.detectChanges();
  }

  malzemeDegisti(): void {
    const ad = this.malzemeler[this.malzemeIdx]?.ad;
    const p = MALZEME_PIYASA[ad]; if (p) { this.fiyatKg = p.fiyatKg; this.mrr = p.mrr; }
    if (this.sonuc) this.olcVeHesapla(); else this.cd.detectChanges();
  }

  /** Sahnedeki/seçili gövdeyi ölç → net+brüt ağırlık + talaş → teklif. */
  olcVeHesapla(): void {
    this.hata = null;
    const sahne = this.anaGosterim?.sahneler?.[0];
    if (!sahne) { this.hata = 'Sahne bulunamadı'; this.cd.detectChanges(); return; }
    const mlz = this.malzemeler[this.malzemeIdx];
    this.mass.malzemeAyarla(mlz);
    const r = this.mass.hesaplaModel(this.modelleme, sahne);   // aktif gövde (yoksa sahne)
    if (!r || r.ucgenSayisi === 0) { this.hata = 'Önce bir model yükleyin/oluşturun'; this.sonuc = null; this.cd.detectChanges(); return; }
    this.netKg = r.agirlik.kg;
    const b = r.boundingBox.boyutlar;
    const bboxCm3 = (b.x * b.y * b.z) / 1000;      // mm³ → cm³
    this.brutKg = bboxCm3 / 1000 * mlz.yogunluk;    // dm³ × yoğunluk
    this.talasCm3 = Math.max(0, bboxCm3 - r.hacim.cm3);
    baglamYaz({ malzeme: mlz.ad, olcu: `${b.x.toFixed(0)}×${b.y.toFixed(0)}×${b.z.toFixed(0)}`, netKg: this.netKg, hacimCm3: r.hacim.cm3, alanDm2: r.yuzeyAlani.cm2 / 100 });
    this.hesapla();
  }

  /** Çapraz-link: ilgili modülü aç (bağlam yazıldı → ön-dolu). */
  ilgiliAc(metod: string): void { try { this.ana?.[metod]?.(); } catch { } }

  hesapla(): void {
    if (!this.netKg && !this.brutKg) return;
    this.sonuc = teklifHesapla({
      netAgirlikKg: this.netKg, brutAgirlikKg: this.brutKg, talasHacimCm3: this.talasCm3,
      malzemeFiyatKg: this.fiyatKg, islemeHizCm3Dk: this.mrr, saatUcreti: this.saatUcreti,
      kurulumDk: this.kurulumDk, kaplamaUcret: this.kaplama, ekIslemUcret: 0,
      karYuzde: this.karYuzde, kdvYuzde: this.kdvYuzde, adet: this.adet, fireYuzde: this.fireYuzde,
    });
    this.cd.detectChanges();
  }

  f(v: number, d = 2): string {
    return (v ?? 0).toLocaleString('tr-TR', { minimumFractionDigits: 0, maximumFractionDigits: d });
  }

  /** Yazdırılabilir teklif penceresi (PDF için tarayıcı yazdır). */
  yazdir(): void {
    if (!this.sonuc) return;
    const s = this.sonuc, mlz = this.malzemeler[this.malzemeIdx].ad;
    const tarih = new Date().toLocaleDateString('tr-TR');
    const w = window.open('', '_blank', 'width=800,height=900');
    if (!w) { this.hata = 'Yazdırma penceresi açılamadı (popup engeli)'; this.cd.detectChanges(); return; }
    const satir = (a: string, b: string, vurgu = false) =>
      `<tr${vurgu ? ' style="background:#eef7ff;font-weight:700"' : ''}><td>${a}</td><td style="text-align:right">${b}</td></tr>`;
    w.document.write(`<!doctype html><html lang="tr"><head><meta charset="utf-8"><title>FikoYT Teklif</title>
    <style>body{font-family:Segoe UI,Arial,sans-serif;color:#13283a;padding:32px;max-width:680px;margin:auto}
    h1{color:#0a84c0;margin:0 0 4px} .sub{color:#789;margin-bottom:24px;font-size:13px}
    table{width:100%;border-collapse:collapse;font-size:14px} td{padding:8px 10px;border-bottom:1px solid #e3edf5}
    .top{background:#0a84c0;color:#fff!important} .top td{color:#fff;font-size:18px;font-weight:700}
    .foot{margin-top:24px;font-size:12px;color:#789}</style></head><body>
    <h1>FikoYT — Fiyat Teklifi</h1><div class="sub">Tarih: ${tarih} · Malzeme: ${mlz} · Adet: ${this.adet}</div>
    <table>
    ${satir('Net / Brüt ağırlık', `${this.f(this.netKg, 2)} / ${this.f(this.brutKg, 2)} kg`)}
    ${satir('Hammadde maliyeti', this.f(s.hammaddeMaliyet) + ' ₺')}
    ${satir(`İşleme (${this.f(s.islemeSureDk, 0)} dk)`, this.f(s.islemeMaliyet) + ' ₺')}
    ${satir('Kurulum (birim)', this.f(s.kurulumBirim) + ' ₺')}
    ${this.kaplama > 0 ? satir('Kaplama/işlem', this.f(s.kaplamaMaliyet) + ' ₺') : ''}
    ${satir('Birim maliyet', this.f(s.birimMaliyet) + ' ₺')}
    ${satir(`Kâr (%${this.karYuzde})`, this.f(s.birimKar) + ' ₺')}
    ${satir('Birim fiyat (KDV hariç)', this.f(s.birimFiyat) + ' ₺', true)}
    ${satir(`KDV %${this.kdvYuzde} dahil birim`, this.f(s.birimKdvli) + ' ₺')}
    <tr class="top"><td>TOPLAM (KDV dahil)</td><td style="text-align:right">${this.f(s.toplamKdvli)} ₺</td></tr>
    </table>
    <div class="foot">Bu teklif tahmini maliyet modeline dayanır ve bilgilendirme amaçlıdır. FikoYT 3D Sistem ile üretilmiştir.</div>
    <script>window.onload=()=>window.print()</script></body></html>`);
    w.document.close();
  }
}
